import React from "react";
import {
  colorBlack,
  colorWhite,
  primaryColor,
} from "../../../utility/constants/colorManager";
import { CustomButton } from "../main_comps/custom_button";

function RowButton({
  onClickNext,
  onClickBack,
  buttonname1 = "Cancel",
  buttonname2 = "Next",
  buttonStyle1,
  buttonStyle2,
  loading = false,
  showAppliedIndicator = false,
}) {
  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        justifyContent: "center",
        marginTop: 20,
      }}
    >
      <CustomButton
        title={buttonname1}
        styles={{
          backgroundColor: colorWhite,
          border: "1px solid black",
          padding: 0,
          height: "auto",
          padding: "10px",
        }}
        textStyles={{
          color: colorBlack,
        }}
        onClick={onClickBack}
      />{" "}
      <CustomButton
        title={buttonname2}
        styles={{
          backgroundColor: primaryColor,
          border: "1px solid black",
          padding: 0,
          height: "auto",
          padding: "10px 25px",
        }}
        textStyles={{
          color: colorWhite,
        }}
        onClick={() => {
          onClickNext();
        }}
        loading={loading}
        showChecked={showAppliedIndicator}
      />
    </div>
  );
}

export default RowButton;
